import { render, staticRenderFns } from "./InsuranceDisc.vue?vue&type=template&id=2008a3b4&scoped=true&"
import script from "./InsuranceDisc.vue?vue&type=script&lang=js&"
export * from "./InsuranceDisc.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceDisc.vue?vue&type=style&index=0&id=2008a3b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2008a3b4",
  null
  
)

export default component.exports